import React from 'react';
import Hero from '../components/Hero';
import ServiceCard from '../components/ServiceCard';
import servicesData from '../data/services.json';
import './Services.css';

const Services: React.FC = () => {
  return (
    <div className="services-page">
      <Hero
        heading={servicesData.hero.heading}
        backgroundImage={servicesData.hero.backgroundImage}
        compact
      />

      <section className="section">
        <div className="container">
          <div className="services-intro">
            <div className="orange-divider" />
            <h2 className="section-heading">{servicesData.intro.heading}</h2>
            <p className="services-intro-text">{servicesData.intro.text}</p>
          </div>
        </div>
      </section>

      <section className="section section-dark">
        <div className="container">
          <div className="services-grid">
            {servicesData.services.map((service, idx) => (
              <ServiceCard
                key={idx}
                title={service.title}
                description={service.description}
                features={service.features}
                ctaText={service.ctaText}
                ctaLink={service.ctaLink}
                image={service.image}
              />
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;
